
export function getLatestToken() {
    if(!localStorage){
        return null;
    }
    
    return localStorage.getItem('token');
}